import { IAppState } from '../../../AppModulesWrapper';

export function selectIsSubagentLimitExceed(state: IAppState): boolean {
  return !!state.servicePickerWidget.publishTerms.message?.subAgentLimitExceed;
}
